module.exports = __webpack_public_path__ + "img/developper.5fe9b563.png";